import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import logo from '../assets/Images/LOGO.jpeg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from '../Config';

const ExampleDiv = styled.div`
  background-color: #e6f7f9;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
overflow-y: auto;

  .container {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    width: 70%;
    height: 76%;
    overflow: hidden;
    @media (max-width: 768px) {
      flex-direction: column;
      height: auto;
    }
  }

  .imageContainer {
    flex: 1;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    height: 100%;
    img {
      width: 80%;
      height: 80%;
      object-fit: cover;
      position: absolute;
      top: 50px;
      left: 50px;
      opacity: 0;
      transition: opacity 1s ease-in-out;
    }
    img.active {
      opacity: 1;
    }
    @media (max-width: 768px) {
      height: 200px;
    }
  }

  .formContainer {
    flex: 0.5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px;
    background-color: white;
    @media (max-width: 768px) {
      padding: 20px;
    }
  }

  .logo {
    display: block;
    margin: 0 auto -15px;
    width: 200px;
  }

  .form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .input {
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    width: 92%;
  }

  .button {
    padding: 10px;
    border-radius: 5px;
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    width: 100%;
  }

  .link {
    background-color: transparent;
    border: none;
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
    margin-top: -63px;
    display: block;
    text-align: right;
    margin-left: 120px;
    font-size: 12px;
  }

  .error {
    color: red;
    margin-top: 45px;
    margin-bottom: -36px;
  }

  .signUpContainer {
    margin-top: 60px;
    text-align: center;
  }

  .signUpLink {
    color: #007bff;
    cursor: pointer;
    text-decoration: underline;
  }

  .signInUsing {
    text-align: center;
    margin: 53px 0 10px;
    // font-size: 16px;
    color: #333;
  }

  .socialButtonsContainer {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
  }

  .socialButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    width: 13%;
    background-color: white;
    cursor: pointer;
    text-align: center;
    height: 46px;
  }

  .socialIcon {
    font-size: 24px;
  }

  .rememberMeContainer {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .rememberMeCheckbox {
    margin-right: 10px;
  }

  .rememberMeLabel {
    // font-size: 14px;
    color: #333;
  }
  .nsm7Bb-HzV7m-LgbsSe-BPrWId span{
  display:none
  }
  .L6cTce{
  display:none
  }
  .nsm7Bb-HzV7m-LgbsSe span{
  height:46px;
  width: 42px;
  }
  nsm7Bb-HzV7m-LgbsSe nsm7Bb-HzV7m-LgbsSe-BPrWId{
  display:none;
  }
`;

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");

    if (storedEmail && storedPassword) {
      setEmail(storedEmail);
      setPassword(storedPassword);
      setRememberMe(true);
    }
    const fetchImages = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/image`);
        const data = await response.json();
        if (response.ok) {
          const updatedImageUrls = data.map(url =>
            url.imageUrl
          );
          setImageUrls(updatedImageUrls);
        } else {
          console.error('Failed to fetch images');
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImages();

    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [imageUrls.length]);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (rememberMe) {
      localStorage.setItem("email", email);
      localStorage.setItem("password", password);
    } else {
      localStorage.removeItem("password");
    }

    if (!validateEmail(email)) {
      setError("Invalid email format.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be at least 6 characters long.");
      return;
    }
    setError("");
    try {
      const response = await fetch(
        `${BASE_URL}/api/user/login?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const data = await response.json();
        setError(data.message || "Something went wrong!");
        alert(`Error: ${data.message || "Login failed"}`);
        return;
      }
      const data = await response.json();
      if (data.subscriptionStatus === "expired") {
        setError("Your subscription is expired.");
        alert("Your subscription is expired. Please renew to continue.");
        return;
      }

      localStorage.setItem("id", data._id);
      localStorage.setItem("UserName", data.name);
      localStorage.setItem("email", data.email);
      localStorage.setItem("WabaId", data?.facebookData?.waba_id || '');
      localStorage.setItem("ClientPhoneNumberId", data?.facebookData?.phone_number_id || '');

      console.log("Login successful!", data);
      onLogin();
      toast.success("Login successful!");
      navigate("/usermanagement");
    } catch (error) {
      console.error("Login error!", error);
      alert("Login error!");
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    return password.length >= 6; // Minimum 6 characters
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  const handleRegister = () => {
    navigate('/signUp');
  };

  return (
    <ExampleDiv>
      <div className="container">
        <div className="imageContainer">
          {imageUrls.length > 0 ? (
            imageUrls.map((url, index) => (
              <img
                key={index}
                src={`${BASE_URL}${url}`}
                alt={`Slideshow ${index}`}
                className={index === currentImageIndex ? "active" : ""}
              />
            ))
          ) : (
            <p>No images available</p>
          )}
        </div>
        <div className="formContainer">
          <img src={logo} alt="Logo" className="logo" />
          <form className="form" onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="rememberMeContainer">
              <input
                type="checkbox"
                id="rememberMe"
                className="rememberMeCheckbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe" className="rememberMeLabel">
                Remember me
              </label>
            </div>
            <button type="submit" className="button">
              Login
            </button>
            <button type="button" className="link" onClick={handleForgotPassword}>
              Forgot Password?
            </button>
            {error && <div className="error">{error}</div>}
          </form>
          <div className="signUpContainer">
            Don’t have an account?{" "}
            <span className="signUpLink" onClick={handleRegister}>
              Register
            </span>
          </div>
        </div>
      </div>
    </ExampleDiv>
  );
};

export default Login;
